module.exports = __webpack_public_path__ + "static/img/12.1f3be4b2.png";